import { type Mode, MODES, DEFAULT_MODE } from './types';
export function deriveMode(pathname: string): Mode {
  const seg = pathname.split('/')[1] as Mode;
  return MODES.includes(seg) ? seg : DEFAULT_MODE;
}
